import React from "react";

import { Modal } from "shared/components/Modal";

import type { InviteAssignmentCompleteResult } from "../EmployeePropertiesModal/AssignEmployeeToPropertiesModalContainer";

export interface InviteEmployeeSuccessModalProps {
  assignment: InviteAssignmentCompleteResult;
  employeeName: string;
  email: string;
}

const InviteEmployeeSuccessModal = ({
  assignment,
  employeeName,
  email,
}: InviteEmployeeSuccessModalProps) => {
  const assigned = !assignment.skipped && assignment.assignedPropertyCount > 0;
  const title = assigned
    ? "Invite sent & properties assigned!"
    : "Invite sent!";
  const body = assigned
    ? `${employeeName} was invited and assigned to ${assignment.assignedPropertyCount} propert${
        assignment.assignedPropertyCount === 1 ? "y" : "ies"
      }. We emailed ${email} with next steps.`
    : `We emailed ${email} with instructions to get started.`;

  return (
    <Modal
      title={title}
      submitButtonLabel="Done"
      submit={() => undefined}
      closeOnSubmit
    >
      <Modal.Body>
        <p>{body}</p>
      </Modal.Body>
    </Modal>
  );
};

export default InviteEmployeeSuccessModal;
